import { Toast as RToast } from 'radix-ui';
import { X } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useStore } from '../../lib/store';
import { TONE_ICONS } from './tones';
import { dismissToast, toastStore } from './toastStore';

const toneClass = {
  info: 'border-info',
  success: 'border-success',
  warning: 'border-warning',
  danger: 'border-danger',
};
const iconClass = { info: 'text-info', success: 'text-success', warning: 'text-warning', danger: 'text-danger' };

/** Renders queued toasts. Mounted once in the app shell; call `toast()` from anywhere. */
export function Toaster() {
  const toasts = useStore(toastStore);
  return (
    <RToast.Provider swipeDirection="right" label="Notification">
      {toasts.map((t) => {
        const Icon = TONE_ICONS[t.tone];
        return (
          <RToast.Root
            key={t.id}
            duration={t.duration ?? (t.tone === 'danger' ? 10_000 : 6_000)}
            type={t.tone === 'danger' ? 'foreground' : 'background'}
            onOpenChange={(open) => {
              if (!open) dismissToast(t.id);
            }}
            className={cn(
              'st-animate-pop flex items-start gap-3 rounded-lg border-l-[6px] bg-surface p-4 text-text shadow-card',
              toneClass[t.tone],
            )}
          >
            <Icon aria-hidden="true" className={cn('mt-0.5 h-6 w-6 shrink-0', iconClass[t.tone])} />
            <div className="flex-1">
              <RToast.Title className="font-bold">{t.title}</RToast.Title>
              {t.description && <RToast.Description className="text-muted">{t.description}</RToast.Description>}
            </div>
            <RToast.Close
              aria-label="Dismiss notification"
              className="-m-2 inline-flex h-11 w-11 items-center justify-center rounded-lg hover:bg-surface-muted"
            >
              <X aria-hidden="true" className="h-5 w-5" />
            </RToast.Close>
          </RToast.Root>
        );
      })}
      <RToast.Viewport className="fixed right-0 bottom-20 z-[60] flex w-full max-w-md flex-col gap-2 p-3 outline-none lg:bottom-0" />
    </RToast.Provider>
  );
}
